/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CandidacyIndexPathParams, CandidacyIndexResponse } from '../types/CandidacyIndex'

/**
 * GET /candidate-center/organisations/:organisation/candidacies
 * @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyController.php CandidacyController::index
 */
export async function candidacyIndex(
	organisation: CandidacyIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidacyIndexResponse>> {
	return axiosInstance.get(`/candidate-center/organisations/${organisation}/candidacies`, config)
}
